import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function createDraft(scheduleId) {
    return mutate(gql`mutation createDraftSchedule {  createDraft(scheduleId: "${scheduleId}") }`)
}
